import "./AddDesignSubsidyQualificationContent.module.css";
import Header from "@/reusable_sections/Header";
import LeadAiTransformationWave from "./sections/LeadAiTransformationWave";
import WhyChooseUs from "./sections/WhyChooseUs";
import MethodologyComparison from "./sections/MethodologyComparison";
import Footer from "@/reusable_sections/Footer";
export default function AddDesignSubsidyQualificationContentPage() {
  return <div>
      <Header />
      <LeadAiTransformationWave />
      <WhyChooseUs />
      <MethodologyComparison />
      <Footer />
    </div>;
}